// src/modules/calendar/utils/colorLegend.js
// Fuente única de verdad de los colores automáticos del calendario y su significado.
// Los eventos se colorean según su posición dentro del cronograma del curso
// (ver getAutoColor en DragDropCalendar.jsx). Esta leyenda se muestra en el sidebar.

export const AUTO_COLORS = {
    firstMC: '#22c55e',   // verde - inicio masterclass (1ª MC del grupo)
    lastMC: '#38bdf8',    // celeste - fin masterclass (última MC del grupo)
    firstCL: '#fbbf24',   // amarillo - inicio clase (1ª CL del grupo)
    lastCL: '#f97316',    // naranja - fin de curso (última CL)
    normal: '#9ca3af',    // gris - sesiones intermedias
    cancelled: '#ef4444', // rojo - evento cancelado
};

// Leyenda legible para mostrar al usuario.
export const COLOR_LEGEND = [
    { color: AUTO_COLORS.firstMC, label: 'Primera masterclass' },
    { color: AUTO_COLORS.lastMC, label: 'Última masterclass' },
    { color: AUTO_COLORS.firstCL, label: 'Primera clase' },
    { color: AUTO_COLORS.lastCL, label: 'Fin de curso (última clase)' },
    { color: AUTO_COLORS.normal, label: 'Sesión intermedia' },
    { color: AUTO_COLORS.cancelled, label: 'Cancelada' },
];
